import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Table as ChakraTable, TableContainer, Tbody } from "@chakra-ui/react";
import { MembershipSelectAction } from "../hooks";
import { PlanRow } from "./PlanRow";
import { PlansTfoot } from "./PlansTfoot";
import { PlansThead } from "./PlansThead";

interface PlanRow {
  copy: string;
  hasPlus: boolean;
  hasPremium: boolean;
}

interface Props {
  action: MembershipSelectAction;
  trackers: {
    plusTracker: () => void;
    premiumTracker: () => void;
  };
}

export const PlansTable: FC<Props> = ({ action, trackers }) => {
  const { t } = useTranslation();

  const planRows = t("planSelect.table.rows", {
    returnObjects: true,
  }) as PlanRow[];

  return (
    <TableContainer rounded="lg" shadow={{ base: "none", lg: "xl" }}>
      <ChakraTable
        variant={{ base: "th-striped-col", md: "th-striped" }}
        size="lg"
      >
        <PlansThead />
        <Tbody>
          {planRows.map((row: PlanRow, index: number) => (
            <PlanRow
              key={index}
              hasPlus={row.hasPlus}
              hasPremium={row.hasPremium}
            >
              {row.copy}
            </PlanRow>
          ))}
        </Tbody>
        <PlansTfoot action={action} trackers={trackers} />
      </ChakraTable>
    </TableContainer>
  );
};
